import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import "./Skeleton.css";

export type SkeletonShape = "text" | "heading" | "avatar" | "rect";

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  shape?: SkeletonShape;
  width?: number | string;
  height?: number | string;
  radius?: number | string;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

const toCss = (v: number | string | undefined) => (typeof v === "number" ? `${v}px` : v);

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
  { shape = "text", width, height, radius, style, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={cx("go4-skeleton", `go4-skeleton--${shape}`, className)}
      style={{
        ...style,
        width: toCss(width),
        height: toCss(height),
        borderRadius: toCss(radius),
      }}
      {...rest}
    />
  );
});
